import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';

interface Props {
  tipsList: string[];
  className?: string;
}

const ChangingTip: React.FC<Props> = (props) => {
  const { tipsList, className } = props;

  const [tipIndex, setTipIndex] = useState(0);

  useEffect(() => {
    const tipsTimer = setInterval(() => {
      setTipIndex((prevIndex) => getRandomIndex(prevIndex, tipsList.length));
    }, 5000);

    return () => clearInterval(tipsTimer);
  }, [tipsList.length]);

  const getRandomIndex = (currentIndex: number, arrayLength: number) => {
    let newIndex;
    do {
      newIndex = Math.floor(Math.random() * arrayLength);
    } while (newIndex === currentIndex);
    return newIndex;
  };

  return <div className={className}>{parse(tipsList[tipIndex])}</div>;
};

export default ChangingTip;
